interface StepItem {
    label: string
    completed?: boolean
}

interface StepperProps {
    steps: StepItem[]
    activeStep: number
    onStepClick?: (index: number) => void
    className?: string
}

export const Stepper = ({ steps, activeStep, onStepClick, className = '' }: StepperProps) => {
    return (
        <div className={`flex items-center ${className}`}>
            {steps.map((step, index) => {
                const isActive = index === activeStep
                const isCompleted = step.completed || index < activeStep
                const isClickable = onStepClick && (isCompleted || index <= activeStep)

                return (
                    <div key={index} className="flex items-center">
                        {/* Step */}
                        <button
                            type="button"
                            onClick={() => isClickable && onStepClick?.(index)}
                            disabled={!isClickable}
                            className={`flex items-center gap-2 ${isClickable ? 'cursor-pointer' : 'cursor-default'}`}
                        >
                            {/* Circle */}
                            <div
                                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                                    isCompleted
                                        ? 'bg-blue-600 text-white'
                                        : isActive
                                          ? 'border-2 border-blue-600 bg-white text-blue-600 dark:bg-slate-900 dark:text-blue-400 dark:border-blue-400'
                                          : 'border-2 border-slate-300 bg-white text-slate-400 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-500'
                                }`}
                            >
                                {isCompleted ? (
                                    <svg
                                        className="h-4 w-4"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                ) : (
                                    index + 1
                                )}
                            </div>
                            {/* Label */}
                            <span
                                className={`hidden text-sm font-medium sm:inline ${
                                    isActive
                                        ? 'text-blue-600 dark:text-blue-400'
                                        : isCompleted
                                          ? 'text-slate-900 dark:text-slate-100'
                                          : 'text-slate-400 dark:text-slate-500'
                                }`}
                            >
                                {step.label}
                            </span>
                        </button>
                        {/* Connector line */}
                        {index < steps.length - 1 && (
                            <div className={`mx-3 h-px w-8 sm:w-12 ${isCompleted ? 'bg-blue-600' : 'bg-slate-300 dark:bg-slate-600'}`} />
                        )}
                    </div>
                )
            })}
        </div>
    )
}
